<script setup>
import { reactive } from 'vue';
import SportLiveTvCatalogEvents from '@/sport-live-tv/components/sport-live-tv-catalog-events.vue';
import SportLiveTvError from '@/sport-live-tv/components/sport-live-tv-error.vue';
import SportLiveTvFilters from '@/sport-live-tv/components/sport-live-tv-filters.vue';
import SportLiveTvLoading from '@/sport-live-tv/components/sport-live-tv-loading.vue';
import { useSportLiveTvCatalog } from '@/sport-live-tv/composables/use-sport-live-tv-catalog';
import { useSportLiveTvFilters } from '@/sport-live-tv/composables/use-sport-live-tv-filters';

const { selection, sort, status, scoresVisible, isFiltered, applySelection, selectLeague, showLive, toggleScores, clearFilters } = useSportLiveTvFilters();

const { categories, teams, rows, featured, live, selectionEvents, isLoading, isError, refetch } = useSportLiveTvCatalog({ selection, status, sort });

const selectionEventsState = reactive(selectionEvents);
</script>

<template>
  <SportLiveTvError v-if="isError" @retry="refetch" />
  <SportLiveTvLoading v-else-if="isLoading" />
  <template v-else>
    <SportLiveTvFilters
      v-model:sort="sort"
      v-model:status="status"
      :categories="categories"
      :teams="teams"
      :selection="selection"
      :scores-visible="scoresVisible"
      @apply="applySelection"
      @clear="clearFilters"
      @toggle-scores="toggleScores"
    />
    <SportLiveTvCatalogEvents
      :is-filtered="isFiltered"
      :selection-events="selectionEventsState"
      :featured="featured"
      :live="live"
      :categories="rows"
      :scores-visible="scoresVisible"
      @clear-filters="clearFilters"
      @select-category="selectLeague"
      @show-live="showLive"
    />
  </template>
</template>
